<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">费用列表</span>
    </div>
    <div class="tab overflow-h">
      <span :class="{'active':screen_data.biz_type==item.biz_type}" v-for="(item,index) in biz_types"
        @click="changeBizTypeTab(item.biz_type)" :key="index">{{biz_config[item.biz_type]}}</span>
      <span @click="changeBizTypeTab(-1)" :class="{'active':screen_data.biz_type==-1}">手动账单</span>
    </div>

    <!-- 前四个账单 中转补货、移库换标、退货质检、PREP、手动账单-->
    <div v-if="screen_data.biz_type!=-1 && screen_data.biz_type<4" class="tab overflow-h">
      <span v-if="screen_data.biz_type!=2" @click="changeTab(1)" :class="{'active':active==1}">入库费</span>
      <span v-if="screen_data.biz_type==2" @click="changeTab(11)" :class="{'active':active==11}">质检费</span>
      <!-- <span @click="changeTab(3)" :class="{'active':active==3}">换标仓储(老版)</span> -->
      <span @click="changeTab(5)" :class="{'active':active==5}">仓储费</span>
      <span @click="changeTab(2)" :class="{'active':active==2}">出库费</span>
      <span @click="changeTab(4)" :class="{'active':active==4}">一件代发</span>
      <span @click="changeTab(6)" :class="{'active':active==6}">废弃处理费</span>
    </div>
    <div class="clear-fix"></div>
    <!-- 中转发货 -->
    <Zhongzhuanfahuo v-if="screen_data.biz_type==4"></Zhongzhuanfahuo>

    <!-- 质检费 -->
    <zhijiandan v-if="active==11"></zhijiandan>

    <div v-if="screen_data.biz_type<4&&active!=11">
      <div class="search-one">
        <div class="search-item">
          客户编号
          <Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入客户名称" />
          仓库
          <Select v-model="warehouse_id" @on-change="warehouseselectevent" class="w200" placeholder="请选择库房" clearable>
            <Option v-for="(option, index) in houseList" :value="option.warehouse_id" :key="index">
              {{option.warehouse_name}}
            </Option>
          </Select>
          状态
          <Select v-model="screen_data.pay_status" style="width: 100px;">
            <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}
            </Option>
          </Select>
        </div>
        <div class="search-item">
          {{bill_code_search_text}}
          <Input class='ml10 mr20 w200' v-model="screen_data.bill_no" placeholder="请输入关键字" />
          创建时间
          <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
          <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
          <button class="ivu-btn ivu-btn-primary fr ml20" @click="batchPay">批量支付</button>
          <button class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出</button>
          <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
        </div>
      </div>
      <div class="clear-fix"></div>
      <Table ref="data_list" :loading="loading" class="mt20" border :columns="table_data.columns"
        :data="table_data.data">
        <template slot-scope="{ row, index }" slot="opeate">
          <span v-if="active!=7" @click="detail(row)" class="blue">详情</span>
          <span v-if="row.pay_status==0" @click="pay(row)" class="blue">支付</span>
        </template>
      </Table>
      <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </div>

    <Modal :title="title" v-model="show_detail" width="1200">
      <div class="details f14">
        <p class="mt10">客户编号: {{detailInfo.client_code}}</p>
        <p class="mt10">客户姓名: {{detailInfo.client_name}}</p>
        <p v-if="active==3" class="mt10">结算日期: {{detailInfo.end_date}}</p>
      </div>
      <!-- 这里需要增加一列 调整 -->
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
        <template slot-scope="{ row, index }" slot="opeate">

        </template>
      </Table>
      <div slot="footer">
        <!-- detail_total_fee -->
        总计：<input v-model="this.detail_total_fee" />
      </div>
    </Modal>


    <!-- 修改调整金额，单价 -->
    <Modal title="调整金额" v-model="modifyprice_show" width="1000">
      <span v-if="this.active!=7">
        单价：
        <InputNumber class='ml10 mr20 w100' v-model="modifyprice_data.unit_price" placeholder="请输入单价" />

      </span>

      调整金额：
      <InputNumber class='ml10 mr20 w100' v-model="modifyprice_data.modify_price" placeholder="请输入调整金额" />
      调整原因：
      <Input class='ml10 mr20 w300' v-model="modifyprice_data.modify_remark" placeholder="备注" />

      <div slot="footer" class="tc">
        <button class="ivu-btn ivu-btn-white" @click="modifyprice_show=false;">取消</button>
        <button class="ivu-btn ivu-btn-primary" @click="ConfirmModifyPrice">确定</button>
      </div>
    </Modal>


    <Modal title="sku明细" v-model="show_sku" width="1000">
      <Table class="mt20" border :columns="sku_columns" :data="sku_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

    <Modal title="每天计费明细" v-model="show_detail_day" width="1000">
      <Table class="mt20" border :columns="show_detail_day_columns" :data="show_detail_day_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

    <Modal title="SKU明细" v-model="show_detail_day_sku" width="1000">
      <Table class="mt20" border :columns="show_detail_day_sku_columns" :data="show_detail_day_sku_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

    <Modal title="每天计费明细" v-model="show_detail_day_in_bill" width="1000">
      <Table class="mt20" border :columns="show_detail_day_columns_in_bill" :data="show_detail_day_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

    <Modal title="包裹明细" v-model="show_detail_day_sku_in_bill" width="1000">
      <Table class="mt20" border :columns="show_detail_day_sku_columns_in_bill" :data="show_detail_day_sku_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

    <Modal title="入库日期" v-model="show_detail_day_sku_indate" width="1000">
      <Table class="mt20" border :columns="show_detail_day_sku_indate_columns" :data="show_detail_day_sku_indate_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

  </main>
</template>

<script>
  import Paging from '@/components/common/paging'
  import Zhongzhuanfahuo from '@/pages/finance/bill/zhongzhuanfahuo'
  import zhijiandan from '@/pages/finance/bill/zhijiandan'
  export default {
    components: {
      Paging,
      Zhongzhuanfahuo,
      zhijiandan
    },
    data() {
      return {
        bill_code_search_text: "",
        warehouse_id: "",
        houseList: [],
        detail_total_fee: 0,
        detail_show_data: {}, //页面上点击查看详情的时候缓存的daa
        //用来记录当前明细中的行数据
        current_detail_row: {},
        title: '', //详情标题
        detailInfo: {}, //详情
        show_detail: false,
        modifyprice_show: false,
        show_sku: false,
        current: {},
        active: 2,
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          biz_type: 1,
          pageNum: 1,
          pageSize: 10,
        },
        modifyprice_data: {}, //修改调整金额的参数实体
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        statusList: [{
          value: '',
          label: '全部'
        }, { //10-待结算，20-已结算，-10-已作废
          value: 0,
          label: '待付款'
        }, {
          value: 1,
          label: '已付款'
        }, {
          value: '-1',
          label: '已作废'
        }],
        detail_columns: [],
        detail_list: [], //详情列表
        sku_list: [],
        sku_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 180,
        }, {
          title: '所属入库包裹',
          key: 'in_bill_no',
          width: 200,
        }, {
          title: '数量',
          key: 'product_count',
          width: 180,
        }, {
          title: '入库时间',
          key: 'in_warehouse_date',
        }],
        fee_type: [],
        fee_type_service: [],
        unit: [{
          value: 10,
          label: 'USD/KG'
        }, {
          value: 20,
          label: 'USD/个'
        }, {
          value: 30,
          label: 'USD/天/个'
        }, {
          value: 40,
          label: 'USPS计费规则'
        }],
        show_detail_day_sku_indate: false,
        show_detail_day_sku_indate_list: [],
        show_detail_day_sku_indate_columns: [{
          title: '入库时间',
          key: 'in_warehouse_date',
          width: 150,
        }, {
          title: '开始计费时间',
          key: 'bill_start_date',
          width: 200,
        }, {
          title: '计算日',
          key: 'fee_date',
          width: 150,
        }, {
          title: '数量',
          key: 'count',
          width: 150,
        }, {
          title: '单价',
          key: 'unit_price',
          width: 150,
        }, {
          title: '小计',
          key: 'total_price',
          width: 200,
        }],
        show_detail_day_sku: false,
        show_detail_day_sku_in_bill: false,
        show_detail_day_sku_list: [],
        show_detail_day_sku_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 200,
        }, {
          title: '数量',
          key: 'product_count',
          width: 200,
        }, {
          title: '单价',
          key: 'unit_price',
          width: 200,
        }, {
          title: '小计费用',
          key: 'total_fee',
          width: 200,
        }, {
          title: '操作',
          key: 'total_fee',
          width: 200,
          render: (h, params) => {
            let doms = [];
            doms.push(h('button', {
              'class': "fc-blue",
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.detailDaySKU(params.row)
                }
              }
            }, '查看'));

            return h("div", doms);
          }
        }],
        show_detail_day_sku_columns_in_bill: [{
          title: '入库单号',
          key: 'sku',
          width: 200,
        }, {
          title: '体积',
          key: 'product_dim',
          width: 200,
        }, {
          title: '单价',
          key: 'unit_price',
          width: 200,
        }, {
          title: '小计费用',
          key: 'total_fee',
          width: 200,
        }],
        show_detail_day: false,
        show_detail_day_in_bill: false,
        show_detail_day_list: [],
        show_detail_day_columns: [{
          title: '日期',
          key: 'fee_date',
          width: 250,
        }, {
          title: 'SKU类型数量',
          key: 'sku_count',
          width: 250,
        }, {
          title: '小计费用',
          key: 'total_fee',
          width: 250,
        }, {
          title: '操作',
          key: 'total_fee',
          width: 250,
          render: (h, params) => {
            let doms = [];
            doms.push(h('button', {
              'class': "fc-blue",
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.detailDay(params.row)
                }
              }
            }, '查看'));

            return h("div", doms);

          }

        }],
        show_detail_day_columns_in_bill: [{
          title: '日期',
          key: 'fee_date',
          width: 250,
        }, {
          title: '包裹数量',
          key: 'sku_count',
          width: 250,
        }, {
          title: '小计费用',
          key: 'total_fee',
          width: 250,
        }, {
          title: '操作',
          key: 'total_fee',
          width: 250,
          render: (h, params) => {
            let doms = [];
            doms.push(h('button', {
              'class': "fc-blue",
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.detailDayInBill(params.row)
                }
              }
            }, '查看'));

            return h("div", doms);
          }

        }],
        biz_types: [],
        biz_config: { //0中转补货， 1-移库换标， 2- 退货质检， 3- PREP， 4-中转发货；
          0: '中转补货',
          1: '移库换标',
          2: '退货质检',
          3: 'PREP',
          4: '中转发货',
        }
      }
    },
    methods: {
      getBiztype() { //业务类型
        this.$axios.get("/client/biz/type").then(res => {
          if (res.data && res.data.length) {
            this.biz_types = res.data || []
            this.screen_data.biz_type = res.data[0].biz_type;
            if (this.screen_data.biz_type == 2) { //退货质检
              this.active = 1;
            }
          }
        });
      },
      init() {
        this.getBiztype()
        this.screen_data.warehouse_id = "";
        this.table_data.columns = this.setColumns();
        this.modifyprice_data.unit_price = 0;
        this.modifyprice_data.modify_price = 0;

        //进行仓库查询 houseList
        this.$axios.get("warehouse/list").then(res => {
          if (res.success && res.data) {
            this.houseList = res.data;
          }
        })

        this.getTypeServiceList();
        this.getList();
      },

      warehouseselectevent(e) {
        if (e == undefined) e = "";
        this.screen_data.warehouse_id = e;
        console.log("仓库id产生编号：" + e)
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList(this.active);
      },

      modifyfunc(row) {
        this.modifyprice_show = true;
        this.current_detail_row = row;
        console.log(this.current_detail_row)
      },

      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList(this.active);
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList(this.active);
      },
      changeTab(type) {
        this.active = type;
        this.screen_data.pageNum = this.page_data.pageIndex = 1;
        this.table_data.columns = this.setColumns();
        if (this.active != 11) {
          this.getList();
        }
      },
      changeBizTypeTab(type) {
        this.screen_data.biz_type = type;
        if (type == -1) {
          this.changeTab(7);
        } else {
          this.getList();
        }
      },
      getTypeServiceList() {
        this.$axios.get("/fee/type/service/list/all", {}).then(res => {
          this.loading = false;

          let types = [];
          if (res.success && res.data && res.data.length) {
            res.data.forEach(function(item, index) {
              let type = {};
              type.label = item.service_type_name;
              type.value = item.service_type_code;
              types.push(type)
            });
          }

          this.fee_type_service = types;
        })
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      getTypeList() {
        this.$axios.get("/fee/type/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = [];
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      /*
       * 获取列表
       */
      getList() {
        let url = ''

        if (this.active == 1) { //入库费
          url = '/ClientBill/fee/inbill';
          this.bill_code_search_text = '快递单号';
        }
        if (this.active == 2) { //出库费
          url = '/ClientBill/fee/outbill';
          this.bill_code_search_text = '出库单号';
        }
        if (this.active == 3) { //仓储费
          url = '/ClientBill/fee/stock';
          this.bill_code_search_text = '账单编号';
        }
        if (this.active == 5) { //仓储费
          if (this.screen_data.biz_type == 0) {
            url = '/ClientBill/fee/stock/in_bill';
          } else {
            url = '/ClientBill/fee/stock/new';
          }
          this.bill_code_search_text = '账单编号';
        }
        if (this.active == 4) { //一件代发费
          url = '/ClientBill/fee/post';
          this.bill_code_search_text = '出库单号';
        }
        if (this.active == 6) { //废弃处理费
          url = '/ClientBill/fee/discardbill';
          this.bill_code_search_text = '废弃单号';
        }
        if (this.active == 7) { //手动账单费
          url = '/ClientBill/fee/checkoffbill';
          this.bill_code_search_text = '扣款单号';
        }
        this.$axios.get(url, {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = [];
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      exportData() {
        let url = ''

        if (this.active == 1) { //入库费
          url = '/ClientBill/fee/inbill/export/excel'
        }
        if (this.active == 2) { //出库费
          url = '/ClientBill/fee/outbill/export/excel'
        }
        if (this.active == 3) { //仓储费
          url = '/ClientBill/fee/stock/export/excel'
        }
        if (this.active == 5) { //仓储费
          if (this.screen_data.biz_type == 0) {
            url = '/ClientBill/fee/stock/export/excel/in_bill';
          } else {
            url = '/ClientBill/fee/stock/export/excel/new'
          }
        }
        if (this.active == 4) { //一件代发费
          url = '/ClientBill/fee/post/export/excel'
        }
        if (this.active == 6) { //废弃处理费L
          url = '/ClientBill/fee/discardbill/export/excel'
        }
        if (this.active == 7) { //手动账单费
          url = '/ClientBill/fee/checkoffbill/excel'
        }

        this.$axios.get(url, {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            if (this.active == 5 || this.active == 1) {
              this.$Message.info(res.data);
            } else {
              let a = document.createElement('a'); //创建一个<a></a>标签
              a.href = res.data; //赋值url
              a.download = res.data; //文件名称
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click(); //点击下载
              a.remove(); //删除标签
              this.$Message.info('下载成功');
            }

          }
        })


      },
      pay(data) {

        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付账单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.payDirectly(that, data);
          },
          onCancel: () => {

          }
        });

      },

      //修改调整金额
      ConfirmModifyPrice() {
        let url = "";
        let bill_no = "";
        const that = this;

        this.modifyprice_data.fee_type = this.current_detail_row.fee_type;

        if (that.active == 1) {
          bill_no = this.current_detail_row.waybill_code;
          url = "/ClientBill/fee/inbill/detail/priceinfo";
          this.modifyprice_data.waybill_code = bill_no;
        }
        if (that.active == 2) {
          bill_no = this.current_detail_row.out_bill_no;
          url = "/ClientBill/fee/outbill/detail/priceinfo";
          this.modifyprice_data.out_bill_no = bill_no;
        }
        if (that.active == 3) {
          that.$Message.success("咱不支持的业务")
          return;
        }
        if (that.active == 5) {
          that.$Message.success("咱不支持的业务")
          return;
        }
        if (that.active == 4) {
          bill_no = this.current_detail_row.out_bill_no;
          url = "/ClientBill/fee/post/detail/priceinfo";
          this.modifyprice_data.out_bill_no = bill_no;
        }
        if (that.active == 6) {
          bill_no = this.current_detail_row.discard_bill_no;
          url = "/ClientBill/fee/discardbill/detail/priceinfo";
          this.modifyprice_data.discard_bill_no = bill_no;
        }
        if (that.active == 7) {

          bill_no = this.current_detail_row.checkoff_direct_no;
          url = "/ClientBill/fee/checkoffbill/priceinfo";
          this.modifyprice_data.checkoff_direct_no = bill_no;
        }


        if (url == false || bill_no == false) {
          that.$Message.success("业务场景暂不支持");
          return;
        }


        //开始进行调用
        that.$axios.put(url,
          this.$qs.stringify(this.modifyprice_data)
        ).then(res => {
          if (res.success) {
            that.$Message.success('操作成功');
            this.modifyprice_data = {};
            this.modifyprice_data.unit_price = "";
            this.modifyprice_data.modify_price = "";
            this.modifyprice_show = false;
            if (that.active != 7) {
              this.detail(this.detail_show_data)
            } else {
              this.getList();
            }
          }
        })

      },


      isNumber(val) {
        return typeof value === 'number' && !isNaN(value);
      },


      payDirectly(that, data) {

        let url = "";
        let bill_no = "";

        if (that.active == 1) {
          bill_no = data.waybill_code;
          url = "/ClientBill/fee/pay/inbill?waybill_code=" + bill_no;
        }
        if (that.active == 2) {
          bill_no = data.out_bill_no;
          url = "/ClientBill/fee/pay/outbill?out_bill_no=" + bill_no;
        }
        if (that.active == 3) {
          bill_no = data.stock_bill_no;
          url = "/ClientBill/fee/pay/stock?stock_bill_no=" + bill_no;
        }
        if (that.active == 5) {
          bill_no = data.stock_bill_no;
          url = "/ClientBill/fee/pay/stock?stock_bill_no=" + bill_no;
        }
        if (that.active == 4) {
          bill_no = data.out_bill_no;
          url = "/ClientBill/fee/pay/post?out_bill_no=" + bill_no;
        }
        if (that.active == 6) {
          bill_no = data.discard_bill_no;
          url = "/ClientBill/fee/pay/discardbill?discard_bill_no=" + bill_no;
        }
        if (that.active == 7) {
          bill_no = data.checkoff_direct_no;
          url = "/ClientBill/fee/pay/checkoffbill?checkoff_direct_no=" + bill_no;
        }

        //这里考虑弄成同步
        that.$axios.post(url).then(res => {
          if (res.success) {
            that.$Message.success('支付成功');
            //调用API刷新页面数据？
            that.getList(that.active);
          }
        })

      },


      GetBillCodeStr(that, data) {

        let url = "";
        let bill_no = "";

        if (that.active == 1) {
          bill_no = data.waybill_code;
          url = "/ClientBill/fee/pay/inbill?waybill_code=" + bill_no;
        }
        if (that.active == 2) {
          bill_no = data.out_bill_no;
          url = "/ClientBill/fee/pay/outbill?out_bill_no=" + bill_no;
        }
        if (that.active == 3) {
          bill_no = data.stock_bill_no;
          url = "/ClientBill/fee/pay/stock?stock_bill_no=" + bill_no;
        }
        if (that.active == 5) {
          bill_no = data.stock_bill_no;
          url = "/ClientBill/fee/pay/stock?stock_bill_no=" + bill_no;
        }
        if (that.active == 4) {
          bill_no = data.out_bill_no;
          url = "/ClientBill/fee/pay/post?out_bill_no=" + bill_no;
        }
        if (that.active == 6) {
          bill_no = data.discard_bill_no;
          url = "/ClientBill/fee/pay/discardbill?discard_bill_no=" + bill_no;
        }
        if (that.active == 7) {
          bill_no = data.checkoff_direct_no;
          url = "/ClientBill/fee/pay/checkoffbill?checkoff_direct_no=" + bill_no;
        }

        return bill_no;

      },

      batchPay() {

        let items = this.$refs.data_list.getSelection();
        if (items.length == 0) {
          this.$Message.error('请选择要支付的账单');
          return;
        }

        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付账单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {

            let bill_nos = "";

            items.forEach(function(item) {
              if (item.pay_status == 0) {
                // that.payDirectly(that, item);
                bill_nos += (that.GetBillCodeStr(that, item) + ",");
              }
            });

            //发起请求
            that.$axios.post("/ClientBill/batch/pay?fee_type=" + that.active + "&bill_nos=" +
              bill_nos).then(res => {
              if (res.success) {
                that.$Message.success(res.data);
                //调用API刷新页面数据？
                that.getList(that.active);
              }
            })


          },
          onCancel: () => {

          }
        });



      },

      detailDaySKU(data) {

        this.$axios.get('ClientBill/fee/stock/day/sku/in', {
          params: {
            sku: data.sku,
            client_code: data.client_code,
            fee_date: data.fee_date,
            warehouse_id: data.warehouse_id
          }

        }).then(res => {
          this.show_detail_day_sku_indate = true
          this.show_detail_day_sku_indate_list = res.data || []
        })
      },
      detailDay(data) {

        this.$axios.get('ClientBill/fee/stock/day/sku', {
          params: {
            client_code: data.client_code,
            fee_date: data.fee_date,
            warehouse_id: data.warehouse_id
          }

        }).then(res => {
          this.show_detail_day_sku = true
          this.show_detail_day_sku_list = res.data || []
        })
      },

      detailDayInBill(data) {

        this.$axios.get('ClientBill/fee/stock/day/in_bill/list', {
          params: {
            client_code: data.client_code,
            fee_date: data.fee_date,
            warehouse_id: data.warehouse_id
          }

        }).then(res => {
          this.show_detail_day_sku_in_bill = true
          this.show_detail_day_sku_list = res.data || []
        })
      },

      detail(data) {
        this.detail_show_data = data;
        if (data.fee_days && data.fee_days > 0) {

          let stock_day_url = 'ClientBill/fee/stock/day?stock_bill_no=' + data.stock_bill_no;
          if (this.screen_data.biz_type == 0) {
            stock_day_url = 'ClientBill/fee/stock/day/in_bill?stock_bill_no=' + data.stock_bill_no;
          }

          this.$axios.get(stock_day_url, {
            headers: {
              noShowError: true
            }
          }).then(res => {
            if (this.screen_data.biz_type == 0) {
              this.show_detail_day_in_bill = true
            } else {
              this.show_detail_day = true
            }
            this.show_detail_day_list = res.data || []
          })
          return;
        }

        this.detailInfo = {
          ...data
        }
        let url = ''
        if (this.active == 1) { //入库费
          url = '/ClientBill/fee/inbill/detail?waybill_code=' + data.waybill_code;
          this.title = '包裹单号：' + data.waybill_code
          this.detail_columns = this.setDetailColumns()
        }
        if (this.active == 2) { //出库费
          url = '/ClientBill/fee/outbill/detail?out_bill_no=' + data.out_bill_no;
          this.title = '出库单号：' + data.out_bill_no
          this.detail_columns = this.setDetailColumns()
        }
        if (this.active == 3) { //仓储费
          url = '/ClientBill/fee/stock/detail?stock_bill_code=' + data.stock_bill_no;
          this.title = '账期：' + data.start_date.substring(0, 7) + '    (' + data.start_date + '至' + data
            .end_date + ')';
          //仓储费详情表头重置
          this.detail_columns = [{
              title: '本期超过免费期（30天）',
              key: 'due_day',
              width: 250,
            }, {
              title: '单价',
              key: 'unit_price',
              width: 180,
              render: (h, params) => {
                //let a = this.unit.find(item => item.value == params.row.unit)
                return h('span', '$' + params.row.unit_price)
              }
            }, {
              title: '商品数量',
              key: 'product_count',
              width: 180,
            }, {
              title: '单价',
              key: 'total_fee',
              width: 180,
              render: (h, params) => {
                //let a = this.unit.find(item => item.value == params.row.unit)
                return h('span', '$' + params.row.total_fee)
              }
            },
            {
              title: '操作',
              render: (h, params) => {
                return h('a', {
                  on: {
                    click: () => {
                      this.getSkuDetail(params.row.stock_bill_detail_id)
                    }
                  }
                }, '查看SKU明细')
              }
            }
          ]
        }
        if (this.active == 4) { //一件代发费
          url = '/ClientBill/fee/post/detail?post_batch_detail_id=' + data.post_batch_detail_id;
          this.title = '出库单号：' + data.out_bill_no
          this.detail_columns = this.setDetailColumns()
        }
        if (this.active == 6) { //废弃费
          url = '/ClientBill/fee/discardbill/detail?discard_bill_no=' + data.discard_bill_no;
          this.title = '废弃单号：' + data.discard_bill_no
          this.detail_columns = this.setDetailColumns()
        }
        this.$axios.get(url, {
          headers: {
            noShowError: true
          }
        }).then(res => {
          this.show_detail = true
          this.detail_list = res || [];
          this.detail_total_fee = 0;
          //这里遍历一下，然后计算出来总金额
          this.detail_list.forEach((item) => {
            if (item.total_fee) {
              this.detail_total_fee += item.total_fee;
            }
          })

          this.detail_total_fee = this.detail_total_fee.toFixed(3)

        })
      },
      setColumns() {
        let arr = [{
            type: 'selection',
            width: 60,
            align: 'center'
          }, {
            title: '包裹号',
            key: 'waybill_code',
            tooltip: true,
            width: 200,
          }, {
            title: '子账户编号',
            key: 'client_code',
            tooltip: true,
            width: 120,
          },
          {
            title: '所属仓库',
            key: 'warehouse_name',
            tooltip: true,
            width: 120,
          },
          {
            title: '姓名',
            key: 'user_name',
            tooltip: true,
            width: 150,
          }, {
            title: 'SKU数',
            key: 'sku_count',
            width: 100,
          }, {
            title: '商品总数',
            key: 'product_count',
            width: 100,
          }, {
            title: '重量(KG)',
            key: 'weight_kg',
            width: 100,
          }, {
            title: '总金额(USD)',
            key: 'total_fee',
            width: 150,
          },
          //9
          {
            title: "状态",
            key: "pay_status",
            width: 100,
            render: (h, params) => {
              let status = params.row.pay_status;
              if (status == 0) {
                return h("span", {
                  style: {
                    color: 'red'
                  }
                }, "待支付");
              } else if (status == 1) {
                return h("span", {
                  style: {
                    color: 'green'
                  }
                }, "已支付");
              } else if (status == -1) {
                return h("span", "已作废");
              }
            }
          },
          {
            title: '费用产生日期',
            key: 'fee_create_date',
            width: 190,
            tooltip: true
          }, {
            title: '操作',
            slot: 'opeate',
          }
        ];
        if (this.active == 2) { //出库费
          arr[1] = {
            title: '出库编号',
            key: 'out_bill_no',
            width: 180,
            tooltip: true
          }
          arr[10] = {
            title: '费用产生日期',
            key: 'fee_create_date',
            width: 180,
            tooltip: true
          }
        }
        if (this.active == 3) { //仓储费
          arr[1] = {
            title: '账单编号',
            key: 'stock_bill_no',
            width: 180,
            tooltip: true
          }
          // arr[6] = {
          // 	width: 1
          // }
          arr[6] = {
            title: '账期时间',
            width: 220,
            tooltip: true,
            render: (h, params) => {
              let txt = params.row.start_date + '-' + params.row.end_date;
              return h("span", txt);
            }
          }
          arr[10] = {
            title: '费用产生日期',
            key: 'create_date',
            width: 180,
            tooltip: true
          }
        }
        if (this.active == 5) { //仓储费
          arr[1] = {
            title: '账单编号',
            key: 'stock_bill_no',
            width: 180,
            tooltip: true
          }
          arr[4] = {
            width: 1
          }
          arr[5] = {
            title: '计费天数',
            key: 'fee_days',
            width: 100,
            tooltip: true
          }
          // arr[6] = {
          // 	width: 1
          // }
          arr[6] = {
            title: '账期时间',
            width: 220,
            tooltip: true,
            render: (h, params) => {
              let txt = params.row.start_date + '-' + params.row.end_date;
              return h("span", txt);
            }
          }
          arr[10] = {
            title: '费用产生日期',
            key: 'create_date',
            width: 180,
            tooltip: true
          }
        }
        if (this.active == 4) { //一件代发费
          arr[1] = {
            title: '出库编号',
            key: 'out_bill_no',
            width: 180,
            tooltip: true
          }
          arr[10] = {
            title: '费用产生日期',
            key: 'fee_create_date',
            width: 180,
            tooltip: true
          }
        }
        if (this.active == 6) { //废弃费
          arr[1] = {
            title: '废弃单号',
            key: 'discard_bill_no',
            width: 180,
            tooltip: true
          }
          arr[10] = {
            title: '费用产生日期',
            key: 'fee_create_date',
            width: 180,
            tooltip: true
          }
        }
        if (this.active == 7) { //废弃费
          arr[1] = {
            title: '扣款单号',
            key: 'checkoff_direct_no',
            width: 180,
            tooltip: true
          }
          arr[2] = {
            width: 1
          }

          arr[4] = {
            width: 1
          }
          arr[5] = {
            width: 1
          }
          arr[6] = {
            minwidth: 200,
            title: '手动扣款说明',
            key: 'remark',
          }
          arr[5] = {
            title: '创建日期',
            key: 'checkoff_date',
            width: 180,
            tooltip: true
          }
          arr[10] = {
            width: 1
          }
        }
        return arr;
      },
      setDetailColumns() {
        let arr = [{
            title: '收费项目',
            key: 'fee_type',
            width: 180,
            render: (h, params) => {
              if (!this.fee_type_service) {
                return h('span', '-');
              }
              let a = this.fee_type_service.find(item => item.value == params.row.fee_type)
              if (!a) {
                return h('span', '-');
              }
              return h('span', a.label)
            }
          }, {
            title: '单价',
            key: 'unit_price',
            width: 180,
            render: (h, params) => {
              let a = this.unit.find(item => item.value == params.row.unit)
              return h('span', params.row.unit_price + a.label)
            }
          }, {
            title: '数量',
            key: 'amount',
            width: 180,
          }, {
            title: '最低收费',
            key: 'min_price',
            width: 180,
          },
          {
            title: '调整金额',
            key: 'modify_price',
            width: 100,
          },
          {
            title: '调整备注',
            key: 'modify_remark',
          },
          {
            title: '小计',
            key: 'total_fee',
            width: 180,
          }
        ]
        return arr;
      },
      getSkuDetail(stock_bill_detail_id) {
        this.$axios.get('/ClientBill/fee/stock/detail/sku?stock_bill_detail_id=' + stock_bill_detail_id, {
          headers: {
            noShowError: true
          }
        }).then(res => {
          this.show_sku = true
          this.sku_list = res || []
        })
      }
    },
    created() {

      this.init();

    }
  }
</script>

<style scoped="scoped">
  .stock .w200 {
    width: 200px !important;
  }

  .tab {
    margin-top: 50px;
  }

  .tab span {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #4f6081;
    text-align: center;
    float: left;
    cursor: pointer;
  }

  .tab span.active {
    background-color: #4f6081;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/bill/detail.vue